import { useEffect, useState } from 'react';
import { firmCatalogApi, type CatalogFirm } from '../lib/api';
import { firms as bundled } from '../data/firms';

/** Prop-firm rules from the server (admin-maintained); the bundled V1 catalogue is the offline fallback. */
export function useFirmCatalog(username: string) {
  const [firms, setFirms] = useState<CatalogFirm[]>(() =>
    bundled.map(f => ({ id: f.id, data: f, source_urls: [], verified_on: null, updated_by: null, updated_at: '' })));
  const [live, setLive] = useState(false);
  useEffect(() => {
    firmCatalogApi.list(username).then(list => { if (list.length) { setFirms(list); setLive(true); } }).catch(() => undefined);
  }, [username]);
  return { firms, live };
}
